// Redux action types
export const CALLEDSET = 'one-state-calling-destination/set';
export const CALLEDREINIT = 'one-state-calldest/reinit';